import React, { Component, Fragment } from 'react'
import TopNavigation from '../components/TopNavigation/header';
import PageTop from '../components/PageTop/PageTop';
import Footer from '../components/Footer/Footer';
import Gallery from '../components/Gallery/Gallery';

export class galleryPage extends Component {
  render() {
    return (
     <Fragment>
            <TopNavigation></TopNavigation>
        <PageTop pageTitle="Gallery"></PageTop>
        <Gallery></Gallery>
        <Footer></Footer>

     </Fragment>
    )
  }
}

export default galleryPage
